import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ShowButton,
  TextInput,
  Filter,
  FunctionField,
  DeleteButton,
} from "react-admin";

const RoleFilter = (props: any) => (
  <Filter {...props}>
    <TextInput source="name_q" label="Nome" alwaysOn />
  </Filter>
);

export const RoleList = () => (
  <List filters={<RoleFilter />} sort={{ field: "id", order: "DESC" }}>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" emptyText="-" />
      <FunctionField
        source="permissions"
        render={(record: any) => {
          const count = record?.permissions?.length || 0;
          return `${count} ${count === 1 ? "permissão" : "permissões"}`;
        }}
      />
      <FunctionField
        render={(record: any) => record?.systemName ? <ShowButton /> : <EditButton />}
      />
      <FunctionField
        render={(record: any) => !record?.systemName && <DeleteButton />}
      />
    </Datagrid>
  </List>
);
